import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Fragment } from "react";
import { Box } from "../../../../../Box/index.js";
import { Typography } from "../../../../../Typography/index.js";
const Group = (t0)=>{
    const $ = c(8);
    const { key, group, children } = t0;
    let t1;
    if ($[0] !== group) {
        t1 = /*#__PURE__*/ jsx(Box, {
            px: "16",
            pt: "8",
            pb: "4",
            children: /*#__PURE__*/ jsx(Typography, {
                component: "span",
                variant: "caption",
                color: "text.light.tertirary",
                children: group
            })
        });
        $[0] = group;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ jsx(Box, {
            children: children
        });
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== key || $[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t1,
                t2
            ]
        }, key);
        $[4] = key;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
export { Group };
